// MainContent.js      here we will display all our modules input and output
import React, { useContext, useState, useEffect } from "react";
import { Layout } from "antd";
import MyContext from "./MyContext";
import BreakEvenTable from "./BreakEvenTable";
import PreferenceMatrix from "./PreferenceMatrix";
import FileManager from "./FileManager";
import MultiproductBreakEven from "./MultiproductBreakEven";
import CrossoverAnalysis from "./CrossoverAnalysis";
import EOQAnalysis from "./EOQAnalysis";
import ABCAnalysis from "./ABCAnalysis";
import KanbanComputation from "./KanbanComputation";
import P_ChartModule from "./P_ChartModule";
import DetermineTimeGivenALearningCoefficient from "./DetermineTimeGivenALearningCoefficient";
import MarkovAnalysis from "./MarkovAnalysis";
import ErlangKServiceTimes from "./ErlangKServiceTimes";
import SingleServerModel from "./SingleServerModel";
import MultipleServerModel from "./MultipleServerModel";
import XBarCharts from "./XBarCharts";
import FiniteSource from "./FiniteSource";
import BinomialDist from "./BinomialDist";
import FiniteSystemSizeModel from "./FiniteSystemSizeModel";
import Simulation from "./Simulation";

import ErrorAnalysis from "./ErrorAnalysis";
import RegressionProjector from "./RegressionProjector";
import EconomicProductionLotSize from "./EconomicProductionLotSize";
import TimeStudy from "./TimeStudy";
import SampleSizeTimeStudy from "./SampleSizeTimeStudy";
import DecisionTable from "./DecisionTable";
import QuantityDiscountEOQ from "./QuantityDiscountEOQ";
import SinglePeriodInventoryDiscrete from "./SinglePeriodInventoryDiscrete";
import SinglePeriodInventoryNormal from "./SinglePeriodInventoryNormal";
import LeastSquares from "./LeastSquares";
import PMMeanStdDev from "./PMMeanStdDev";

import ReorderPointNormalDist from "./ReorderPointNormalDist";
import ReorderPointSafetyStock from "./ReorderPointSafetyStock";
import AggregatePlanning from "./AggregatePlanning";
import TimeSeriesAnalysis from "./TimeSeriesAnalysis";
import Transport from "./Transport";
import CenterOfGravity from "./CenterOfGravity";
import NormalDistribution from "./NormalDistribution";
import TransportModel from "./TransportModel";
import PoissonDistribution from "./PoissonDistribution";
import Cpk from "./Cpk";
import ExponentialDistribution from "./ExponentialDistribution";
import ConstantServiceTimes from "./ConstantServiceTimes";
import GeneralServiceTimes from "./GeneralServiceTimes";
import DataAnalysis from "./DataAnalysis";
import LinearProgramming from "./LinearProgramming";
import GeneralWeightingMethod from "./GeneralWeightingMethod";
import CostBudgeting from "./CostBudgeting";


import UniversalModuleModal from "./UniversalModuleModal";
import { MODULE_MODAL_CONFIGS } from "./moduleModalConfigs";
const { Content } = Layout;

function MainContent() {
  const {
    selectedKey,
    setSelectedKey,
    isModalVisible,
    setIsModalVisible,
    selectedFile,
    setSelectedFile,
    setShowMultiProductModal,
    showMultiProductModal,
    showCrossoverModal,
    setShowCrossoverModal,
  } = useContext(MyContext);
  // REPLACE 37 separate state variables (showABCModal, showDecisionTableModal...) with:
  const [activeModalKey, setActiveModalKey] = useState(null); // e.g. 'abc', 'decision_table', 'binomial'
  const [modalInitialValues, setModalInitialValues] = useState(null);
  //const modalConfig = activeModalKey ? MODULE_MODAL_CONFIGS[activeModalKey] : null;



  const [matrixConfig, setMatrixConfig] = useState(null);
  const [showSetupModal, setShowSetupModal] = useState(false);
  const [crossoverConfig, setCrossoverConfig] = useState(null);
  const [multiProductConfig, setMultiProductConfig] = useState(null);
  const [isSaved, setIsSaved] = useState(false);
  const [showABCModal, setShowABCModal] = useState(false);
  const [abcConfig, setABCConfig] = useState(null);
  const [showErrorAnalysisModal, setShowErrorAnalysisModal] = useState(false);
  const [errorAnalysisConfig, setErrorAnalysisConfig] = useState(null);

  const [showRegressionProjectorModal, setShowRegressionProjectorModal] =
    useState(false);
  const [regressionProjectorConfig, setRegressionProjectorConfig] =
    useState(null); //Data handling modal and file

  const [showTimeStudyModal, setShowTimeStudyModal] = useState(false);
  const [timeStudyConfig, setTimeStudyConfig] = useState(null);

  const [showSampleSizeTimeStudyModal, setShowSampleSizeTimeStudyModal] =
    useState(false);
  const [sampleSizaTimeStudyConfig, setSampleSizaTimeStudyConfig] =
    useState(null);

  const [showDecisionTableModal, setShowDecisionTableModal] = useState(false);
  const [decisionTableConfig, setDecisionTableConfig] = useState(null);

  const [showQuantityDiscountModal, setShowQuantityDiscountModal] =
    useState(false);
  const [quantityDiscountConfig, setQuantityDiscountConfig] = useState(null);

  const [
    showSinglePeriodInventoryDiscreteModal,
    setShowSinglePeriodInventoryDiscreteModal,
  ] = useState(false);
  const [
    singlePeriodInventoryDiscreteConfig,
    setSinglePeriodInventoryDiscreteConfig,
  ] = useState(null);
  const [showSinglePeriodInventoryNormalModal,
    setShowSinglePeriodInventoryNormalModal,
  ] = useState(false);
  const [
    singlePeriodInventoryNormalConfig,
    setSinglePeriodInventoryNormalConfig,
  ] = useState(null);

  const [showLeastSquaresModal, setShowLeastSquaresModal] = useState(false);
  const [leastSquaresConfig, setLeastSquaresConfig] = useState(null);

  const [showKanbanModal, setShowKanbanModal] = useState(false);
  const [kanbanConfig, setKanbanConfig] = useState(null);

  const [showPMMeanStdDevModal, setShowPMMeanStdDevModal] = useState(false);
  const [pmMeanStdDevConfig, setPMMeanStdDevConfig] = useState(null);

  const [showReorderPointSafetyStockModal, setShowReorderPointSafetyStockModal] = useState(false);
  const [reorderPointSafetyStockConfig, setReorderPointSafetyStockConfig] = useState(null);

  const [showAggregatePlanningModal, setShowAggregatePlanningModal] = useState(false);
  const [aggregatePlanningConfig, setAggregatePlanningConfig] = useState(null);

  const [showTimeSeriesAnalysisModal, setShowTimeSeriesAnalysisModal] = useState(false);
  const [timeSeriesAnalysisConfig, setTimeSeriesAnalysisConfig] = useState(null);

  const [showTransportModal, setShowTransportModal] = useState(false);
  const [transportConfig, setTransportConfig] = useState(null);

  const [showCenterOfGravityModal, setShowCenterOfGravityModal] = useState(false);
  const [centerOfGravityConfig, setCenterOfGravityConfig] = useState(null);
  const [showNormalDistributionModal, setShowNormalDistributionModal] = useState(false);
  const [normalDistributionConfig, setNormalDistributionConfig] = useState(null);

  const [showPChartModal, setShowPChartModal] = useState(false);
  const [pChartConfig, setPChartConfig] = useState(null);

  const [showDetermineTimeModal, setShowDetermineTimeModal] = useState(false);
  const [determineTimeConfig, setDetermineTimeConfig] = useState(null);

  const [showMarkovModal, setShowMarkovModal] = useState(false);
  const [markovConfig, setMarkovConfig] = useState(null);

  const [showErlangKModal, setShowErlangKModal] = useState(false);
  const [erlangKConfig, setErlangKConfig] = useState(null);

  const [singleServerConfig, setSingleServerConfig] = useState(null);
  const [multipleServerConfig, setMultipleServerConfig] = useState(null);

  const [showXBarChartsModal, setShowXBarChartsModal] = useState(false);
  const [xBarChartsConfig, setXBarChartsConfig] = useState(null);

  const [finiteSourceConfig, setFiniteSourceConfig] = useState(null);
  const [showFiniteSourceModal, setShowFiniteSourceModal] = useState(false);
  const [finiteSystemSizeConfig, setFiniteSystemSizeConfig] = useState(null);

  const [binomialDistConfig, setBinomialDistConfig] = useState(null);
  const [showBinomialDistModal, setShowBinomialDistModal] = useState(false);


  const [showTransportModelModal, setShowTransportModelModal] = useState(false);
  const [transportModelConfig, setTransportModelConfig] = useState(null);

  const [poissonDistributionConfig, setPoissonDistributionConfig] = useState(null);
  const [showPoissonDistributionModal, setShowPoissonDistributionModal] = useState(false);

  const [linearProgrammingConfig, setLinearProgrammingConfig] = useState(null);

  const [dataAnalysisConfig, setDataAnalysisConfig] = useState(null);
  const [showDataAnalysisModal, setShowDataAnalysisModal] = useState(false);

  const [costBudgetingConfig, setCostBudgetingConfig] = useState(null);
  const [showCostBudgetingModal, setShowCostBudgetingModal] = useState(false);

  const [cpkConfig, setCpkConfig] = useState(null);
  const [showCpkModal, setShowCpkModal] = useState(false);

  const [exponentialConfig, setExponentialConfig] = useState(null);
  const [showExponentialModal, setShowExponentialModal] = useState(false);
  const [constantServiceConfig, setConstantServiceConfig] = useState(null);
  const [showConstantServiceModal, setShowConstantServiceModal] = useState(false);
  const [generalServiceConfig, setGeneralServiceConfig] = useState(null);
  const [showGeneralServiceModal, setShowGeneralServiceModal] = useState(false);
  const [weightingConfig, setWeightingConfig] = useState(null);
  const [simulationConfig, setSimulationConfig] = useState(null);
  useEffect(() => {
    if (selectedFile) {
      const typeToModalKeyMap = {
        simulation: 'simulation',
        abc: 'abc',
        decision_table: 'decision_table',
        binomial: 'binomial',
        binomial_distribution: 'binomial',
        poisson: 'poisson',
        poisson_distribution: 'poisson',
        transport: 'transport',
        transport_model: 'transport_model',
        transportation_model: 'transport_model',
        preference_matrix: 'preference_matrix',
        config: 'preference_matrix',
        single_server: 'single_server',
        single_server_model: 'single_server',
        multiple_server: 'multiple_server',
        multiple_server_model: 'multiple_server',
        aggregate_planning: 'aggregate_planning',
        crossover: 'crossover',
        multiproduct: 'multiproduct',
        kanban: 'kanban',
        p_chart: 'p_chart',
        P_ChartModule_QualityAndPerformance: 'p_chart',
        x_bar_chart: 'x_bar_chart',
        x_bar_charts: 'x_bar_chart',
        determine_time: 'determine_time',
        learning_curve_determine_time: 'determine_time',
        markov: 'markov',
        markov_analysis: 'markov',
        erlang_k: 'erlang_k',
        finite_source: 'finite_source',
        finite_system_size: 'finite_system_size',
        erroranalysis: 'error_analysis',
        error_analysis: 'error_analysis',
        regressionprojector: 'regression',
        regression: 'regression',
        timestudy: 'time_study',
        time_study: 'time_study',
        samplesize_timestudy: 'sample_size_time_study',
        sample_size_time_study: 'sample_size_time_study',
        quantity_discount_EOQ: 'quantity_discount',
        quantity_discount: 'quantity_discount',
        single_period_discrete: 'single_period_discrete',
        single_period_normal: 'single_period_normal',
        least_squares: 'least_squares',
        pm_mean_std_dev: 'pm_mean_std_dev',
        pm_mean_stddev: 'pm_mean_std_dev',
        reorderpoint_discrete: 'reorder_point_discrete',
        reorder_point_safety_stock: 'reorder_point_safety_stock',
        reorderpoint_normaldist: 'reorder_point_safety_stock',
        time_series_analysis: 'time_series',
        time_series: 'time_series',
        center_of_gravity: 'center_of_gravity',
        normal_distribution: 'normal_dist',
        normal_dist: 'normal_dist',
        cpk: 'cpk',
        exponential: 'exponential',
        Exponential: 'exponential',
        constant_service: 'constant_service',
        constant_service_times: 'constant_service',
        data_analysis: 'data_analysis',
        linear_programming: 'linear_programming',
        general_weighting: 'general_weighting',
        weighting_method: 'general_weighting',
        cost_budgeting: 'cost_budgeting'
      };

      const modalKey = typeToModalKeyMap[selectedFile.type];

      if (!selectedFile.id && modalKey) {
        setActiveModalKey(modalKey);
        setModalInitialValues(null);
      }
    }
  }, [selectedFile]);

  const handleUniversalConfirm = (modalKey, values) => {
    switch (modalKey) {
      case 'abc':
        setABCConfig(values);
        break;
      case 'decision_table':
        setDecisionTableConfig(values);
        break;
      case 'binomial':
        setBinomialDistConfig(values);
        break;
      case 'poisson':
        setPoissonDistributionConfig(values);
        break;
      case 'transport':
        setTransportConfig(values);
        break;
      case 'transport_model':
        setTransportModelConfig(values);
        break;
      case 'preference_matrix':
        setMatrixConfig(values);
        break;
      case 'single_server':
        setSingleServerConfig(values);
        break;
      case 'multiple_server':
        setMultipleServerConfig(values);
        break;
      case 'aggregate_planning':
        setAggregatePlanningConfig(values);
        break;
      case 'crossover':
        setCrossoverConfig(values);
        break;
      case 'multiproduct':
        setMultiProductConfig(values);
        break;
      case 'kanban':
        setKanbanConfig(values);
        break;
      case 'p_chart':
        setPChartConfig(values);
        break;
      case 'x_bar_chart':
        setXBarChartsConfig(values);
        break;
      case 'determine_time':
        setDetermineTimeConfig(values);
        break;
      case 'markov':
        setMarkovConfig(values);
        break;
      case 'erlang_k':
        setErlangKConfig(values);
        break;
      case 'finite_source':
        setFiniteSourceConfig(values);
        break;
      case 'finite_system_size':
        setFiniteSystemSizeConfig(values);
        break;
      case 'error_analysis':
        setErrorAnalysisConfig(values);
        break;
      case 'regression':
        setRegressionProjectorConfig(values);
        break;
      case 'time_study':
        setTimeStudyConfig(values);
        break;
      case 'sample_size_time_study':
        setSampleSizaTimeStudyConfig(values);
        break;
      case 'quantity_discount':
        setQuantityDiscountConfig(values);
        break;
      case 'single_period_discrete':
        setSinglePeriodInventoryDiscreteConfig(values);
        break;
      case 'single_period_normal':
        setSinglePeriodInventoryNormalConfig(values);
        break;
      case 'least_squares':
        setLeastSquaresConfig(values);
        break;
      case 'pm_mean_std_dev':
        setPMMeanStdDevConfig(values);
        break;
      case 'reorder_point_safety_stock':
        setReorderPointSafetyStockConfig(values);
        break;
      case 'time_series':
        setTimeSeriesAnalysisConfig(values);
        break;
      case 'center_of_gravity':
        setCenterOfGravityConfig(values);
        break;
      case 'normal_dist':
        setNormalDistributionConfig(values);
        break;
      case 'cpk':
        setCpkConfig(values);
        break;
      case 'exponential':
        setExponentialConfig(values);
        break;
      case 'constant_service':
        setConstantServiceConfig(values);
        break;
      case 'general_service':
        setGeneralServiceConfig(values);
        break;
      case 'data_analysis':
        setDataAnalysisConfig(values);
        break;
      case 'linear_programming':
        setLinearProgrammingConfig(values);
        break;
      case 'general_weighting':
        setWeightingConfig(values);
        break;
      case 'simulation':
        setSimulationConfig(values);
        break;
      case 'cost_budgeting':
        setCostBudgetingConfig(values);
        break;
      default:
        console.warn(`No config state handler for ${modalKey}`);
    }
    setActiveModalKey(null);
  };

  // When selectedFile changes, reset config and show setup modal if needed
  useEffect(() => {
    if (selectedFile) {
      if (selectedFile.type === "config") {
        // Reset config when a new file is selected
        setMatrixConfig(null);
        if (!selectedFile.id) {
          setShowSetupModal(true);
        }
      } else if (selectedFile.type === "multiproduct") {
        // Show multiproduct setup when a new file is created
        setMultiProductConfig(null);
        if (!selectedFile.id) {
          setShowMultiProductModal(true);
        }
      } else if (selectedFile.type === "linear_programming") {
        setLinearProgrammingConfig(null);
      } else if (selectedFile.type === "crossover") {
        setCrossoverConfig(null);
        if (!selectedFile.id) {
          setShowCrossoverModal(true);
        }
      }
      else if (selectedFile.type === "data_analysis") {
        setDataAnalysisConfig(null);

        if (!selectedFile.id)
          setShowDataAnalysisModal(true);
      } else if (selectedFile.type === "abc") {
        setABCConfig(null);
        if (!selectedFile.id) {
          setShowABCModal(true);
        }
      } else if (selectedFile.type === "erroranalysis") {
        setErrorAnalysisConfig(null);
        if (!selectedFile.id) {
          setShowErrorAnalysisModal(true);
        }
      } else if (selectedFile.type === "regressionprojector") {
        setRegressionProjectorConfig(null);
        if (!selectedFile.id) {
          setShowRegressionProjectorModal(true);
        }
      } else if (selectedFile.type === "timestudy") {
        setTimeStudyConfig(null);
        if (!selectedFile.id) {
          setShowTimeStudyModal(true);
        }
      } else if (selectedFile.type === "samplesize_timestudy") {
        setSampleSizaTimeStudyConfig(null);
        if (!selectedFile.id) {
          setShowSampleSizeTimeStudyModal(true);
        }
      } else if (selectedFile.type === "decision_table") {
        setDecisionTableConfig(null);
        if (!selectedFile.id) {
          setShowDecisionTableModal(true);
        }
      } else if (selectedFile.type === "quantity_discount_EOQ") {
        setQuantityDiscountConfig(null);
        if (!selectedFile.id) {
          setShowQuantityDiscountModal(true);
        }
      } else if (selectedFile.type === "single_period_discrete") {
        setSinglePeriodInventoryDiscreteConfig(null);
        if (!selectedFile.id) setShowSinglePeriodInventoryDiscreteModal(true);
      } else if (selectedFile.type === "single_period_normal") {
        setSinglePeriodInventoryNormalConfig(null);
        if (!selectedFile.id) setShowSinglePeriodInventoryNormalModal(true);
      } else if (selectedFile.type === "least_squares") {
        setLeastSquaresConfig(null);
        if (!selectedFile.id) setShowLeastSquaresModal(true);
      } else if (selectedFile.type === "pm_mean_stddev") {
        setPMMeanStdDevConfig(null);
        if (!selectedFile.id) setShowPMMeanStdDevModal(true);
      } else if (selectedFile.type === "reorderpoint_discrete") {
        setReorderPointSafetyStockConfig(null);
        if (!selectedFile.id) setShowReorderPointSafetyStockModal(true);
      } else if (selectedFile.type === "reorderpoint_normaldist") {
        // No modal needed, but we can clear any configs if necessary
      } else if (selectedFile.type === "aggregate_planning") {
        setAggregatePlanningConfig(null);
        if (!selectedFile.id) setShowAggregatePlanningModal(true);
      } else if (selectedFile.type === "time_series_analysis") {
        setTimeSeriesAnalysisConfig(null);
        if (!selectedFile.id) setShowTimeSeriesAnalysisModal(true);
      } else if (selectedFile.type === "transport") {
        setTransportConfig(null);
        if (!selectedFile.id) setShowTransportModal(true);
      }
      else if (selectedFile.type === "center_of_gravity") {
        setCenterOfGravityConfig(null);
        if (!selectedFile.id) setShowCenterOfGravityModal(true);
      } else if (selectedFile.type === "normal_distribution") {
        setNormalDistributionConfig(null);
        if (!selectedFile.id) setShowNormalDistributionModal(true);
      } else if (selectedFile.type === "P_ChartModule_QualityAndPerformance") {
        setPChartConfig(null);
        if (!selectedFile.id) setShowPChartModal(true);
      } else if (selectedFile.type === "learning_curve_determine_time") {
        setDetermineTimeConfig(null);
        if (!selectedFile.id) setShowDetermineTimeModal(true);
      } else if (selectedFile.type === "markov_analysis") {
        setMarkovConfig(null);
        if (!selectedFile.id) setShowMarkovModal(true);
      } else if (selectedFile.type === "erlang_k") {
        setErlangKConfig(null);
        if (!selectedFile.id) setShowErlangKModal(true);
      } else if (selectedFile.type === "single_server_model") {
        setSingleServerConfig(null);
        // Bypass setup modal because FileManager.js already asks for the file name!
      } else if (selectedFile.type === "multiple_server_model") {
        setMultipleServerConfig(null);
        // Bypass setup modal because FileManager.js already asks for the file name!
      } else if (selectedFile.type === "x_bar_charts") {
        setXBarChartsConfig(null);
        if (!selectedFile.id) setShowXBarChartsModal(true);
      } else if (selectedFile.type === "finite_source") {
        setFiniteSourceConfig(null);
        if (!selectedFile.id) setShowFiniteSourceModal(true);
      } else if (selectedFile.type === "finite_system_size") {
        setFiniteSystemSizeConfig(null);
      } else if (selectedFile.type === "binomial_distribution") {
        setBinomialDistConfig(null);
        if (!selectedFile.id) setShowBinomialDistModal(true);
      } else if (selectedFile.type === "cost_budgeting") {
        setCostBudgetingConfig(null);
        if (!selectedFile.id) setShowCostBudgetingModal(true);
      }

      //     else if (selectedFile.type === "kanban") {
      //       setKanbanConfig(null);
      //       if (!selectedFile.id) {
      //         setShowKanbanModal(true);
      //       }
      //     }
      else if (selectedFile.type === "constant_service_times") {
        setConstantServiceConfig(null);

        if (!selectedFile.id)
          setShowConstantServiceModal(true);
      }
      else if (selectedFile.type === "general_service_times") {
        setGeneralServiceConfig(null);

        if (!selectedFile.id)
          setShowGeneralServiceModal(true);
      }
      else if (selectedFile.type === "transportation_model") {
        setTransportModelConfig(null);
        if (!selectedFile.id) setShowTransportModelModal(true);
      }
      else if (selectedFile.type === "poisson_distribution") {
        setPoissonDistributionConfig(null);
        if (!selectedFile.id) setShowPoissonDistributionModal(true);
      }
      else if (selectedFile.type === "cpk") {
        setCpkConfig(null);
        if (!selectedFile.id) setShowCpkModal(true);
      }
      else if (selectedFile.type === "exponential") {
        setExponentialConfig(null);
        if (!selectedFile.id) setShowExponentialModal(true);
      }
      else if (selectedFile.type === "general_weighting" || selectedFile.type === "weighting_method") {
        setWeightingConfig(null);
      }
      else if (selectedFile.type === "simulation") {
        setSimulationConfig(null);
      } else if (selectedFile.type === "cost_budgeting") {
        setCostBudgetingConfig(null);
        if (!selectedFile.id) setShowCostBudgetingModal(true);
      }

    }
  }, [selectedFile]);


  // Add Kanban handler
  // const handleKanbanSetup = (config) => {
  //   setKanbanConfig(config);
  //   setShowKanbanModal(false);
  // };
  //
  // // Add Kanban Modal close handler
  // const handleKanbanModalClose = () => {
  //   if (!kanbanConfig && selectedKey === "10") {
  //     setSelectedKey(null);
  //   }
  //   setShowKanbanModal(false);
  // };

  // Add ABC Analysis handler
  const handleABCSetup = (config) => {
    setABCConfig(config);
    setShowABCModal(false);
  };

  // Add ABC Modal close handler
  const handleABCModalClose = () => {
    if (!abcConfig && selectedKey === "9") {
      setSelectedKey(null);
    }
    setShowABCModal(false);
  };

  // Add Error Analysis handler
  const handleErrorAnalysisSetup = (config) => {
    setErrorAnalysisConfig(config);
    setShowErrorAnalysisModal(false);
  };

  // Add Error Analysis Modal close handler
  const handleErrorAnalysisModalClose = () => {
    if (!errorAnalysisConfig && selectedKey === "12") {
      setSelectedKey(null);
    }
    setShowErrorAnalysisModal(false);
  };

  // Add Regression Projector handler
  const handleRegressionProjectorSetup = (config) => {
    setRegressionProjectorConfig(config);
    setShowRegressionProjectorModal(false);
  };

  // Add Regression Projector Modal close handler
  const handleRegressionProjectorModalClose = () => {
    if (!regressionProjectorConfig && selectedKey === "6") {
      setSelectedKey(null);
    }
    setShowRegressionProjectorModal(false);
  };

  // Add Time Study handler
  const handleTimeStudySetup = (config) => {
    setTimeStudyConfig(config);
    setShowTimeStudyModal(false);
  };

  // Add Regression Projector Modal close handler
  const handleTimeStudyModalClose = () => {
    if (!timeStudyConfig && selectedKey === "14") {
      setSelectedKey(null);
    }
    setShowTimeStudyModal(false);
  };

  // Add Sample Size Time Study handler
  const handleSampleSizeTimeStudySetup = (config) => {
    setSampleSizaTimeStudyConfig(config);
    setShowSampleSizeTimeStudyModal(false);
  };

  // Add Regression Projector Modal close handler
  const handleSampleSizeTimeStudyModalClose = () => {
    if (!sampleSizaTimeStudyConfig && selectedKey === "15") {
      setSelectedKey(null);
    }
    setShowSampleSizeTimeStudyModal(false);
  };

  // Add Decision Table Study handler
  const handleDecisionTableSetup = (config) => {
    // setDecisionTableConfig(config);
    setDecisionTableConfig({
      num_options: config.numRows,
      num_scenarios: config.numCols,
      row_names: config.rowNames,
      column_names: config.colNames,
    });
    setShowDecisionTableModal(false);
  };

  // Add Regression Projector Modal close handler
  const handleDecisionTableModalClose = () => {
    if (!decisionTableConfig && selectedKey === "21") {
      setSelectedKey(null);
    }
    setShowDecisionTableModal(false);
  };

  // Add Quantity Discount Study handler
  const handleQuantityDiscountSetup = (config) => {
    setQuantityDiscountConfig(config);
    setShowQuantityDiscountModal(false);
  };

  // Add Quantity Discount Modal close handler
  const handleQuantityDiscountModalClose = () => {
    if (!quantityDiscountConfig && selectedKey === "23") {
      setSelectedKey(null);
    }
    setShowQuantityDiscountModal(false);
  };

  // Add Single Period Inventory Discrete handler
  const handleSinglePeriodInventoryDiscreteSetup = (config) => {
    setSinglePeriodInventoryDiscreteConfig(config);
    setShowSinglePeriodInventoryDiscreteModal(false);
  };

  // Add Single Period Inventory Discrete Modal close handler
  const handleSinglePeriodInventoryDiscreteModalClose = () => {
    if (!quantityDiscountConfig && selectedKey === "17") {
      setSelectedKey(null);
    }
    setShowSinglePeriodInventoryDiscreteModal(false);
  };
  // Add Single Period Inventory Normal handler
  const handleSinglePeriodInventoryNormalSetup = (config) => {
    setSinglePeriodInventoryNormalConfig(config);
    setShowSinglePeriodInventoryNormalModal(false);
  };

  // Add Single Period Inventory Normal Modal close handler
  const handleSinglePeriodInventoryNormalModalClose = () => {
    if (!singlePeriodInventoryNormalConfig && selectedKey === "18") {
      setSelectedKey(null);
    }
    setShowSinglePeriodInventoryNormalModal(false);
  };

  const handleLeastSquaresSetup = (config) => {
    setLeastSquaresConfig(config);
    setShowLeastSquaresModal(false);
  };

  const handleLeastSquaresModalClose = () => {
    setShowLeastSquaresModal(false);
  };
  const handleConstantServiceSetup = (config) => {
    setConstantServiceConfig(config);
    setShowConstantServiceModal(false);
  };

  const handleConstantServiceModalClose = () => {
    if (!constantServiceConfig && selectedKey === "56") {
      setSelectedKey(null);
    }
    setShowConstantServiceModal(false);
  };
  const handlePMMeanStdDevSetup = (config) => {
    setPMMeanStdDevConfig(config);
    setShowPMMeanStdDevModal(false);
  };

  const handlePMMeanStdDevModalClose = () => {
    if (!pmMeanStdDevConfig && selectedKey === "24") {
      setSelectedKey(null);
    }
    setShowPMMeanStdDevModal(false);
  };

  const handleReorderPointSafetyStockSetup = (config) => {
    setReorderPointSafetyStockConfig(config);
    setShowReorderPointSafetyStockModal(false);
  };

  const handleReorderPointSafetyStockModalClose = () => {
    if (!reorderPointSafetyStockConfig && selectedKey === "19") {
      setSelectedKey(null);
    }
    setShowReorderPointSafetyStockModal(false);
  };

  const handleAggregatePlanningSetup = (config) => {
    setAggregatePlanningConfig(config);
    setShowAggregatePlanningModal(false);
  };

  const handleAggregatePlanningModalClose = () => {
    if (!aggregatePlanningConfig && selectedKey === "25") {
      setSelectedKey(null);
    }
    setShowAggregatePlanningModal(false);
  };

  const handleTimeSeriesAnalysisSetup = (config) => {
    setTimeSeriesAnalysisConfig(config);
    setShowTimeSeriesAnalysisModal(false);
  };

  const handleTimeSeriesAnalysisModalClose = () => {
    if (!timeSeriesAnalysisConfig && selectedKey === "11") {
      setSelectedKey(null);
    }
    setShowTimeSeriesAnalysisModal(false);
  };
  const handleGeneralServiceSetup = (config) => {
    setGeneralServiceConfig(config);
    setShowGeneralServiceModal(false);
  };

  const handleGeneralServiceModalClose = () => {
    if (!generalServiceConfig && selectedKey === "57") {
      setSelectedKey(null);
    }
    setShowGeneralServiceModal(false);
  };
  const handleTransportSetup = (config) => {
    setTransportConfig(config);
    setShowTransportModal(false);
  };

  const handleTransportModalClose = () => {
    if (!transportConfig && selectedKey === "26") {
      setSelectedKey(null);
    }
    setShowTransportModal(false);
  };

  const handleCenterOfGravitySetup = (config) => {
    setCenterOfGravityConfig(config);
    setShowCenterOfGravityModal(false);
  };

  const handleCenterOfGravityModalClose = () => {
    if (!centerOfGravityConfig && selectedKey === "53") {
      setSelectedKey(null);
    }
    setShowCenterOfGravityModal(false);
  };
  const handleNormalDistributionSetup = (config) => {
    setNormalDistributionConfig(config);
    setShowNormalDistributionModal(false);
  };

  const handleNormalDistributionModalClose = () => {
    if (!normalDistributionConfig && selectedKey === "27") {
      setSelectedKey(null);
    }
    setShowNormalDistributionModal(false);
  };

  const handlePChartSetup = (config) => {
    setPChartConfig(config);
    setShowPChartModal(false);
  };

  const handlePChartModalClose = () => {
    if (!pChartConfig && selectedKey === "28") {
      setSelectedKey(null);
    }
    setShowPChartModal(false);
  };

  const handleDetermineTimeSetup = (config) => {
    setDetermineTimeConfig(config);
    setShowDetermineTimeModal(false);
  };

  const handleDetermineTimeModalClose = () => {
    if (!determineTimeConfig && selectedKey === "29") {
      setSelectedKey(null);
    }
    setShowDetermineTimeModal(false);
  };


  const handleMarkovSetup = (config) => {
    setMarkovConfig(config);
    setShowMarkovModal(false);
  };

  const handleMarkovModalClose = () => {
    if (!markovConfig && selectedKey === "30") {
      setSelectedKey(null);
    }
    setShowMarkovModal(false);
  };

  const handleErlangKSetup = (config) => {
    setErlangKConfig(config);
    setShowErlangKModal(false);
  };

  const handleErlangKModalClose = () => {
    if (!erlangKConfig && selectedKey === "58") {
      setSelectedKey(null);
    }
    setShowErlangKModal(false);
  };

  const handleXBarChartsSetup = (config) => {
    setXBarChartsConfig(config);
    setShowXBarChartsModal(false);
  };

  const handleXBarChartsModalClose = () => {
    if (!xBarChartsConfig && selectedKey === "31") {
      setSelectedKey(null);
    }
    setShowXBarChartsModal(false);
  };

  const handleFiniteSourceSetup = (config) => {
    setFiniteSourceConfig(config);
    setShowFiniteSourceModal(false);
  };

  const handleFiniteSourceModalClose = () => {
    if (!finiteSourceConfig && selectedKey === "60") {
      setSelectedKey(null);
    }
    setShowFiniteSourceModal(false);
  };

  const handleBinomialDistSetup = (config) => {
    setBinomialDistConfig(config);
    setShowBinomialDistModal(false);
  };

  const handleBinomialDistModalClose = () => {
    if (!binomialDistConfig && selectedKey === "49") {
      setSelectedKey(null);
    }
    setShowBinomialDistModal(false);
  };
  const handleCostBudgetingSetup = (config) => {
    setCostBudgetingConfig(config);
    setShowCostBudgetingModal(false);
  };
  const handleCostBudgetingModalClose = () => {
    if (!costBudgetingConfig && selectedKey === "43") {
      setSelectedKey(null);
    }
    setShowCostBudgetingModal(false);
  };
  const handleExponentialModal = (config) => {
    setExponentialConfig(config);
    setShowExponentialModal(false);
  };

  const handleExponentialModalClose = () => {
    if (!exponentialConfig && selectedKey === "51") {
      setSelectedKey(null);
    }
    setShowExponentialModal(false);
  };

  // ...existing code...
  // const handleFeatureASetup = (config) => {
  //   setFeatureAConfig(config);
  //   setShowFeatureAModal(false);
  // };

  // const handleFeatureAModalClose = () => {
  //   if (!someRelatedConfig && selectedKey === "A") {
  //     setSelectedKey(null);
  //   }
  //   setShowFeatureAModal(false);
  // };

  // const handleFeatureBSetup = (config) => {
  //   setFeatureBConfig(config);
  //   setShowFeatureBModal(false);
  // };

  // const handleFeatureBModalClose = () => {
  //   if (!otherRelatedConfig && selectedKey === "B") {
  //     setSelectedKey(null);
  //   }
  //   setShowFeatureBModal(false);
  // };
  // ...existing code...
  const handleCrossoverSetup = (config) => {
    setCrossoverConfig(config);
    setShowCrossoverModal(false);
  };
  //    // Enhanced menu selection handling
  //     useEffect(() => {
  //         console.log("Selected key changed:", selectedKey);
  //         if (selectedKey === "3") { // Multiproduct Breakeven Analysis
  // //             setShowMultiProductModal(true);
  //             // Ensure a temporary file is created if no file exists
  //             if (!selectedFile) {
  //                 setSelectedFile({
  //
  //                     type: "multiproduct"
  //                 });
  //             }
  //         }
  //     }, [selectedKey]);

  // Handle preference matrix setup completion
  const handleMatrixSetup = (config) => {
    console.log("Matrix configuration received:", config);
    setMatrixConfig(config);
    // Ensure selectedFile is not null
    if (!selectedFile) {
      console.error("Error: selectedFile is null during setup.");
      return;
    }

    //     setSelectedFile({ ...selectedFile, type: "config" });
    console.log("After setting config, selectedFile is:", selectedFile); // Add this line
    setShowSetupModal(false);
  };
  const handleDataAnalysisSetup = (config) => {
    setDataAnalysisConfig(config);
    setShowDataAnalysisModal(false);
  };

  const handleDataAnalysisModalClose = () => {
    if (!dataAnalysisConfig && selectedKey === "48") {
      setSelectedKey(null);
    }
    setShowDataAnalysisModal(false);
  };

  // Handle multiproduct setup completion
  const handleMultiProductSetup = (config) => {
    console.log("Multiproduct configuration received:", config);

    console.log("setSelectedFile type:", typeof setSelectedFile);
    console.log(
      "setShowMultiProductModal type:",
      typeof setShowMultiProductModal
    );

    setMultiProductConfig(config);

    // Check before calling setSelectedFile
    if (!selectedFile) {
      console.error("Error: selectedFile is null during setup.");
      return;
    }

    // Check before calling setShowMultiProductModal
    if (typeof setShowMultiProductModal === "function") {
      console.log("Closing modal...");
      setShowMultiProductModal(false);
    } else {
      console.error(
        "setShowMultiProductModal is not a function",
        setShowMultiProductModal
      );
    }
  };

  // Handle modal close without configuration
  const handleSetupModalClose = () => {
    setShowSetupModal(false);
  };

  // Handle multiproduct modal close without configuration
  const handleMultiProductModalClose = () => {
    if (!multiProductConfig && selectedKey === "3") {
      setSelectedKey(null);
    }
    setShowMultiProductModal(false);
  };
  const handlePoissonDistributionSetup = (config) => {
    setPoissonDistributionConfig(config);
    setShowPoissonDistributionModal(false);
  };
  const handleCpkSetup = (config) => {
    setCpkConfig({
      upper_specification: config.upper_specification,
      lower_specification: config.lower_specification,
      mean: config.mean,
      standard_deviation: config.standard_deviation,
    });
    setShowCpkModal(false);
  };

  const handleCpkModalClose = () => {
    if (!cpkConfig && (selectedKey === "33" || selectedKey === "66")) {
      setSelectedKey(null);
    }
    setShowCpkModal(false);
  };

  const handlePoissonDistributionModalClose = () => {
    if (!poissonDistributionConfig && selectedKey === "50") {
      setSelectedKey(null);
    }
    setShowPoissonDistributionModal(false);
  };


  // Debug logging
  // useEffect(() => {
  //   console.log("Current state:", {
  //     selectedKey,
  //     selectedFile,
  //     matrixConfig,
  //     showSetupModal,
  //     multiProductConfig,
  //     showMultiProductModal,
  //   });
  // }, [
  //   selectedKey,
  //   selectedFile,
  //   matrixConfig,
  //   showSetupModal,
  //   multiProductConfig,
  //   showMultiProductModal,
  // ]);

  if (!selectedFile) {
    return (
      <Layout style={{ padding: "16px" }}>
        <Content
          style={{
            maxHeight: "calc(100vh - 64px)",
            overflowY: "auto",
            padding: "16px",
            backgroundColor: "#fff",
          }}
        >
          <FileManager />
          <UniversalModuleModal
            isVisible={!!activeModalKey}
            config={MODULE_MODAL_CONFIGS[activeModalKey]}
            initialValues={modalInitialValues}
            onClose={() => setActiveModalKey(null)}
            onConfirm={(values) => handleUniversalConfirm(activeModalKey, values)}
          />
          <div style={{ textAlign: "center", marginTop: "100px" }}>
            <h3>Select or create a file from the sidebar</h3>
          </div>
        </Content>
      </Layout>
    );
  }

  return (
    <Layout style={{ padding: "16px" }}>
      <Content
        style={{
          maxHeight: "calc(100vh - 64px)",
          overflowY: "auto",
          padding: "16px",
          backgroundColor: "#fff",
        }}
      >
        <FileManager />
        {/* Single Universal Modal replaces 37 modal JSX elements */}
        <UniversalModuleModal
          isVisible={!!activeModalKey}
          config={MODULE_MODAL_CONFIGS[activeModalKey]}
          initialValues={modalInitialValues}
          onClose={() => setActiveModalKey(null)}
          onConfirm={(values) => handleUniversalConfirm(activeModalKey, values)}
        />

        {/* Render different content based on file type */}
        {
          selectedFile.type === "direct" && (
            <BreakEvenTable
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              isSaved={isSaved}
              setIsSaved={setIsSaved}
            />
          )
        }

        {
          (selectedFile.type === "config" || selectedFile.type === "preference_matrix") && (
            <PreferenceMatrix
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              matrixConfig={matrixConfig}
              setSelectedFile={setSelectedFile}
            />
          )
        }

        {
          selectedFile.type === "multiproduct" && (
            <MultiproductBreakEven
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={multiProductConfig}
            />
          )
        }

        {
          selectedFile?.type === "crossover" && (
            <CrossoverAnalysis
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={crossoverConfig}
            />
          )
        }

        {
          selectedFile.type === "EOQ" && (
            <EOQAnalysis
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              isSaved={isSaved}
              setIsSaved={setIsSaved}
            />
          )
        }

        {
          selectedFile.type === "exponential" && (
            <ExponentialDistribution
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={exponentialConfig}
            />
          )
        }

        {
          selectedFile?.type === "abc" && (
            <ABCAnalysis
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={abcConfig}
            />
          )
        }

        {
          (selectedFile?.type === "erroranalysis" || selectedFile?.type === "error_analysis") && (
            <ErrorAnalysis
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={errorAnalysisConfig}
            />
          )
        }

        {
          (selectedFile?.type === "regressionprojector" || selectedFile?.type === "regression") && (
            <RegressionProjector
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={regressionProjectorConfig}
            />
          )
        }

        {
          (selectedFile?.type === "timestudy" || selectedFile?.type === "time_study") && (
            <TimeStudy
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={timeStudyConfig}
            />
          )
        }

        {
          (selectedFile?.type === "samplesize_timestudy" || selectedFile?.type === "sample_size_time_study") && (
            <SampleSizeTimeStudy
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={sampleSizaTimeStudyConfig}
            />
          )
        }

        {
          selectedFile?.type === "decision_table" && (
            <DecisionTable
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={decisionTableConfig}
            />
          )
        }

        {
          (selectedFile?.type === "quantity_discount_EOQ" || selectedFile?.type === "quantity_discount") && (
            <QuantityDiscountEOQ
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={quantityDiscountConfig}
            />
          )
        }

        {
          selectedFile?.type === "single_period_discrete" && (
            <SinglePeriodInventoryDiscrete
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={singlePeriodInventoryDiscreteConfig}
            />
          )
        }

        {
          selectedFile?.type === "single_period_normal" && (
            <SinglePeriodInventoryNormal
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={singlePeriodInventoryNormalConfig}
            />
          )
        }

        {
          selectedFile?.type === "least_squares" && (
            <LeastSquares
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={leastSquaresConfig}
            />
          )
        }

        {
          (selectedFile?.type === "pm_mean_stddev" || selectedFile?.type === "pm_mean_std_dev") && (
            <PMMeanStdDev
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={pmMeanStdDevConfig}
            />
          )
        }

        {
          selectedFile.type === "productionlotsize" && (
            <EconomicProductionLotSize
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              isSaved={isSaved}
              setIsSaved={setIsSaved}
            />
          )
        }

        {
          selectedFile?.type === "kanban" && (
            <KanbanComputation
              key={selectedFile.id}
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={kanbanConfig}
            />
          )
        }

        {
          selectedFile.type === "reorderpoint_normaldist" && (
            <ReorderPointNormalDist
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              isSaved={isSaved}
              setIsSaved={setIsSaved}
            />
          )
        }

        {
          (selectedFile.type === "reorderpoint_discrete" || selectedFile?.type === "reorder_point_safety_stock") && (
            <ReorderPointSafetyStock
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={reorderPointSafetyStockConfig}
            />
          )
        }

        {
          selectedFile?.type === "aggregate_planning" && (
            <AggregatePlanning
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={aggregatePlanningConfig}
            />
          )
        }

        {
          (selectedFile?.type === "general_weighting" || selectedFile?.type === "weighting_method") && (
            <GeneralWeightingMethod
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              weightingConfig={weightingConfig}
            />
          )
        }

        {
          (selectedFile?.type === "time_series_analysis" || selectedFile?.type === "time_series") && (
            <TimeSeriesAnalysis
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={timeSeriesAnalysisConfig}
            />
          )
        }

        {
          selectedFile?.type === "transport" && (
            <Transport
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={transportConfig}
            />
          )
        }

        {
          selectedFile?.type === "center_of_gravity" && (
            <CenterOfGravity
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={centerOfGravityConfig}
            />
          )
        }

        {
          (selectedFile?.type === "normal_distribution" || selectedFile?.type === "normal_dist") && (
            <NormalDistribution
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={normalDistributionConfig}
            />
          )
        }

        {
          selectedFile.type === "cpk" && (
            <Cpk
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={cpkConfig}
            />
          )
        }

        {
          (selectedFile.type === "P_ChartModule_QualityAndPerformance" || selectedFile.type === "p_chart") && (
            <P_ChartModule
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={pChartConfig}
            />
          )
        }

        {
          (selectedFile.type === "learning_curve_determine_time" || selectedFile.type === "determine_time") && (
            <DetermineTimeGivenALearningCoefficient
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={determineTimeConfig}
            />
          )
        }

        {
          (selectedFile.type === "markov_analysis" || selectedFile.type === "markov") && (
            <MarkovAnalysis
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={markovConfig}
            />
          )
        }

        {
          selectedFile.type === "erlang_k" && (
            <ErlangKServiceTimes
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={erlangKConfig}
            />
          )
        }

        {
          (selectedFile.type === "single_server_model" || selectedFile.type === "single_server") && (
            <SingleServerModel
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={singleServerConfig}
            />
          )
        }

        {
          (selectedFile.type === "multiple_server_model" || selectedFile.type === "multiple_server") && (
            <MultipleServerModel
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={multipleServerConfig}
            />
          )
        }

        {
          (selectedFile.type === "x_bar_charts" || selectedFile.type === "x_bar_chart") && (
            <XBarCharts
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={xBarChartsConfig}
            />
          )
        }

        {
          selectedFile.type === "finite_source" && (
            <FiniteSource
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={finiteSourceConfig}
            />
          )
        }

        {
          selectedFile.type === "finite_system_size" && (
            <FiniteSystemSizeModel
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={finiteSystemSizeConfig}
            />
          )
        }

        {
          (selectedFile.type === "binomial_distribution" || selectedFile.type === "binomial") && (
            <BinomialDist
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={binomialDistConfig}
            />
          )
        }

        {
          (selectedFile?.type === "transportation_model" || selectedFile?.type === "transport_model") && (
            <TransportModel
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={transportModelConfig}
            />
          )
        }

        {
          (selectedFile.type === "poisson_distribution" || selectedFile.type === "poisson") && (
            <PoissonDistribution
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={poissonDistributionConfig}
            />
          )
        }

        {
          (selectedFile.type === "constant_service_times" || selectedFile.type === "constant_service") && (
            <ConstantServiceTimes
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={constantServiceConfig}
            />
          )
        }

        {
          (selectedFile.type === "general_service_times" || selectedFile.type === "general_service") && (
            <GeneralServiceTimes
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={generalServiceConfig}
            />
          )
        }

        {
          selectedFile.type === "data_analysis" && (
            <DataAnalysis
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={dataAnalysisConfig}
            />
          )
        }

        {
          selectedFile.type === "linear_programming" && (
            <LinearProgramming
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={linearProgrammingConfig}
            />
          )
        }

        {
          selectedFile.type === "simulation" && (
            <Simulation
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={simulationConfig}
            />
          )
        }

        {
          selectedFile.type === "cost_budgeting" && (
            <CostBudgeting
              fileId={selectedFile.id}
              fileName={selectedFile.name}
              setSelectedFile={setSelectedFile}
              initialConfig={costBudgetingConfig}
            />
          )
        }
      </Content >
    </Layout >
  );
}

export default MainContent;
